/* eslint-disable no-new */
import Swiper from 'swiper';
import {
    Navigation, A11y, Keyboard, Pagination,
} from 'swiper/modules';
import announcer from './aria-announcer';

const elementMessage = 'Carrousel d\'éléments';
const nextElement = 'Élément suivant';
const prevElement = 'Élément précédent';
const getAdjacentSlidesLabels = (el) => {
    const prevSlide = el.querySelector('.swiper-button-prev');
    const nextSlide = el.querySelector('.swiper-button-next');
    const prevLabel = prevSlide.getAttribute('aria-label');
    const nextLabel = nextSlide.getAttribute('aria-label');
    return { prevLabel, nextLabel };
};

document.addEventListener('DOMContentLoaded', () => {
    const updateSlideAccessibility = ({ slides, activeIndex }) => {
        slides.forEach((slide, index) => {
            const isActive = index === activeIndex;
            slide.setAttribute('tabindex', isActive ? '0' : '-1');
            slide.setAttribute('aria-hidden', (!isActive).toString());
        });
    };

    // Quick Access Swiper
    const quickAccessSwiper = document.querySelector('.swiper-quick-access');
    const quickAccessSwiperPrev = quickAccessSwiper?.querySelector('.swiper-button-prev');
    const quickAccessSwiperNext = quickAccessSwiper?.querySelector('.swiper-button-next');
    if (quickAccessSwiper) {
        new Swiper(quickAccessSwiper, {
            modules: [Navigation, Keyboard, A11y],
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            navigation: {
                addIcons: false,
                nextEl: quickAccessSwiperNext,
                prevEl: quickAccessSwiperPrev,
            },
            keyboard: {
                enabled: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                },
            },
            on: {
                init: (element) => {
                    updateSlideAccessibility(element);
                },
                slideChangeTransitionEnd: (element) => {
                    updateSlideAccessibility(element);
                },
            },
            a11y: {
                enabled: true,
                containerMessage: elementMessage,
                prevSlideMessage: prevElement,
                nextSlideMessage: nextElement,
                slideRole: 'Liens rapides',
            },
        });
        quickAccessSwiperNext.addEventListener('click', (e) => {
            const { nextLabel } = getAdjacentSlidesLabels(e);
            announcer.announce(`Élément suivant ${nextLabel}`);
        });
        quickAccessSwiperPrev.addEventListener('click', (e) => {
            const { prevLabel } = getAdjacentSlidesLabels(e);
            announcer.announce(`Élément précédent ${prevLabel}`);
        });
    }
    // Clickable Tiles Swiper
    const clickableTilesSwiper = document.querySelector('.swiper-clickable-tiles');
    const clickableTilesSwiperPrev = clickableTilesSwiper?.querySelector('.swiper-button-prev');
    const clickableTilesSwiperNext = clickableTilesSwiper?.querySelector('.swiper-button-next');
    function initClickableTilesSwiper() {
        const isMobile = window.matchMedia('(max-width: 1000px)').matches;
        if (clickableTilesSwiper && isMobile) {
            new Swiper(clickableTilesSwiper, {
                modules: [Navigation, Keyboard, A11y],
                slidesPerView: 'auto',
                spaceBetween: 32,
                navigation: {
                    addIcons: false,
                    nextEl: clickableTilesSwiperNext,
                    prevEl: clickableTilesSwiperPrev,
                },
                keyboard: {
                    enabled: true,
                },
                on: {
                    init: (element) => {
                        updateSlideAccessibility(element);
                    },
                    slideChangeTransitionEnd: (element) => {
                        updateSlideAccessibility(element);
                    },
                },
                a11y: {
                    enabled: true,
                    containerMessage: elementMessage,
                    prevSlideMessage: prevElement,
                    nextSlideMessage: nextElement,
                    paginationBulletMessage: 'Aller à l\'élément {{index}}',
                },
            });
            clickableTilesSwiperNext.addEventListener('click', (e) => {
                const { nextLabel } = getAdjacentSlidesLabels(e);
                announcer.announce(`Élément suivant ${nextLabel}`);
            });
            clickableTilesSwiperPrev.addEventListener('click', (e) => {
                const { prevLabel } = getAdjacentSlidesLabels(e);
                announcer.announce(`Élément précédent ${prevLabel}`);
            });
        }
    }
    initClickableTilesSwiper();
    window.addEventListener('resize', () => {
        const isMobile = window.matchMedia('(max-width: 1000px)').matches;
        if (clickableTilesSwiper) {
            if (isMobile) {
                initClickableTilesSwiper();
            } else if (clickableTilesSwiper.swiper) {
                clickableTilesSwiper.swiper.destroy(true, true);
            }
        }
    });

    const $blockImage = document.querySelectorAll('.block-img-swiper');
    $blockImage.forEach((el) => {
        const swiper = el.querySelector('.swiper');
        const btnPrev = el.querySelector('.button-swiper-prev');
        const btnNext = el.querySelector('.button-swiper-next');

        // init swiper
        new Swiper(swiper, {
            modules: [Navigation, Pagination, A11y, Keyboard],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            navigation: {
                addIcons: false,
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            on: {
                init: (element) => {
                    updateSlideAccessibility(element);
                },
                slideChangeTransitionEnd: (element) => {
                    updateSlideAccessibility(element);
                },
            },
            a11y: {
                enabled: true,
                containerMessage: elementMessage,
                prevSlideMessage: prevElement,
                nextSlideMessage: nextElement,
                paginationBulletMessage: 'Aller à l\'élément {{index}}',
            },
            keyboard: {
                enabled: true,
            },
            pagination: {
                el: '.swiper-pagination',
            },
        });

        btnNext.addEventListener('click', (e) => {
            const { nextLabel } = getAdjacentSlidesLabels(e);
            announcer.announce(`Élément suivant ${nextLabel}`);
        });

        btnPrev.addEventListener('click', (e) => {
            const { prevLabel } = getAdjacentSlidesLabels(e);
            announcer.announce(`Élément précédent ${prevLabel}`);
        });
    });

    const $blockArticles = document.querySelectorAll('.block-articles-swiper');
    $blockArticles.forEach((el) => {
        const swiper = el.querySelector('.swiper');
        const btnPrev = el.querySelector('.button-swiper-prev');
        const btnNext = el.querySelector('.button-swiper-next');

        // init swiper
        new Swiper(swiper, {
            modules: [Navigation, A11y, Keyboard],
            slidesPerView: 1,
            spaceBetween: 32,
            loop: true,
            navigation: {
                addIcons: false,
                nextEl: btnNext,
                prevEl: btnPrev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
            },
            on: {
                init: (element) => {
                    updateSlideAccessibility(element);
                },
                slideChangeTransitionEnd: (element) => {
                    updateSlideAccessibility(element);
                },
            },
            a11y: {
                enabled: true,
                containerMessage: elementMessage,
                prevSlideMessage: prevElement,
                nextSlideMessage: nextElement,
                paginationBulletMessage: 'Aller à l\'élément {{index}}',
            },
            keyboard: {
                enabled: true,
            },
        });

        btnNext.addEventListener('click', (e) => {
            const { nextLabel } = getAdjacentSlidesLabels(e);
            announcer.announce(`Élément suivant ${nextLabel}`);
        });

        btnPrev.addEventListener('click', (e) => {
            const { prevLabel } = getAdjacentSlidesLabels(e);
            announcer.announce(`Élément précédent ${prevLabel}`);
        });
    });
});
